module.exports = __webpack_public_path__ + "static/npckc4-121384946c4bb7088666271417b07485.png";